import * as GLOBALS from "../globals";

const transitionIndizes = 4;

export default class AnimationGrid {
    grid = null;
    animationTiles = null;

    static initAll() {
        const animationGrids = document.querySelectorAll('.animation-grid-container, .animation-grid-container-hero');

        if (animationGrids.length === 0)
            return;

        animationGrids.forEach((grid) => {
            if (grid.classList.contains("animation-grid-container-hero"))
                new AnimationGrid(grid, true);
            else 
                new AnimationGrid(grid);
        });
    }

    constructor(grid, hero = false) {
        this.grid = grid;
        this.animationTiles = this.grid.querySelectorAll('.animation-tile');

        if (this.animationTiles.length === 0)
            return;

        this.initScreenSize(hero);
        this.initGrid();
        this.initInterval();

        window.addEventListener("resize", () => this.initScreenSize(hero));
    }

    initGrid() {
        this.animationTiles.forEach((tile) => {
            this.enableImage(tile.children[0]);
        });
    }
    
    initInterval() {
        setInterval(async () => {
            for(let i = 0; i < transitionIndizes; i++) {
                this.startTransitionForTileGroup(i);
                await this.sleep(500);
            }
        }, 5000);
    }
    
    initScreenSize(hero) {
        if (hero) {
            if (window.innerWidth < GLOBALS.BREAKPOINT_MD) {
                this.animationTiles.forEach((tile, index) => {
                    if (((index+1) % 4) == 0)
                        this.disableTile(tile);
                });
            } else {
                this.animationTiles.forEach((tile, index) => {
                    if (((index+1) % 4) == 0) 
                        this.enableTile(tile)
                });
            }
        } else {
            if (window.innerWidth < GLOBALS.BREAKPOINT_MD) {
                this.animationTiles.forEach((tile, index) => {
                    if (((index+1) % 7) == 4 || ((index+1) % 7) == 5)
                        this.disableTile(tile);
                    if (((index+1) % 7) == 6 || ((index+1) % 7) == 0)
                        this.disableTile(tile);
                });
            }
            if(window.innerWidth < GLOBALS.BREAKPOINT_LG && window.innerWidth > GLOBALS.BREAKPOINT_MD) {
                this.animationTiles.forEach((tile, index) => {
                    if (((index+1) % 7) == 4 || ((index+1) % 7) == 5) 
                        this.enableTile(tile);
                    if (((index+1) % 7) == 6 || ((index+1) % 7) == 0)
                        this.disableTile(tile);
                });
            } 
            if (window.innerWidth > GLOBALS.BREAKPOINT_LG) {
                this.animationTiles.forEach((tile, index) => {
                    if (((index+1) % 7) >= 4 || ((index+1) % 7) == 0) 
                        this.enableTile(tile)
                });
            }
        }
    }

    sleep(milliseconds) {
        return new Promise(resolve => setTimeout(resolve, milliseconds));
    }

    async startTransitionForTileGroup(transitionIndex) {
        this.animationTiles.forEach((tile) => {
            if (tile.dataset.transitionIndex == transitionIndex) {
                this.transitionToNextImage(tile);
            }
        });
    }

    async transitionToNextImage(tile) {
        const children = Array.from(tile.children);

        children.every((childNode, index) => {
            if (childNode.style.opacity == 1) {
                this.disableImage(childNode);
                this.enableImage(children[(index+1) % children.length]);
                return false;
            }

            return true;
        });
    }

    disableImage(imageContainer) {
        imageContainer.style.opacity = "0";
    }

    enableImage(imageContainer) {
        imageContainer.style.opacity = "1";
    }

    disableTile(tile) {
        tile.style.display = "none";
    }

    enableTile(tile)    {
        tile.style.display = "block";
    }
}